import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from './AsyncComponent'

import Footer from './interface/components/Footer'
// import Home from './interface/components/Home/Index'
// import Work from './interface/components/Our Work/Index'
// import Philosophy from './interface/components/Philosophy/Index'
// import Team from './interface/components/The Team/Index'
// import BI from './interface/components/Bootcamp & Internships/Index'
// import Contact from './interface/components/Contact Us/Index'

const Contact = asyncComponent(() => {
  return (
      import('./interface/components/Contact Us/Index').then(module => module.default)
)}
)

const BI = asyncComponent(() => {
  return (
      import('./interface/components/Bootcamp & Internships/Index').then(module => module.default)
)}
)

const Read = asyncComponent(() => {
  return (
      import('./interface/components/Read-Toolkit/Index').then(module => module.default)
)}
)

const Team = asyncComponent(() => {
  return (
      import('./interface/components/The Team/Index').then(module => module.default)
)}
)

const Philosophy = asyncComponent(() => {
  return (
      import('./interface/components/Philosophy/Index').then(module => module.default)
)}
)

const Work = asyncComponent(() => {
  return (
      import('./interface/components/Our Work/Index').then(module => module.default)
)}
)

const Home = asyncComponent(() => {
  return (
      import('./interface/components/Home/Index').then(module => module.default)
)}
)

class App extends Component {
  render() {
    return (
      <div className="App">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/ourwork" component={Work} />
            <Route exact path="/team" component={Team} />
            <Route exact path="/philosophy" component={Philosophy} />
            <Route exact path="/bootcampinternships" component={BI} />
            <Route exact path="/contactus" component={Contact} />
            <Route exact path="/read-toolkit" component={Read} />
          </Switch>
          <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js